/*
 * MDB shim for CardHeader
 * Files currently importing this symbol from "mdbreact":
 * - src/Seating/Accounts/accountDetail.jsx
 * - src/Seating/Activities/activities-add.jsx
 * - src/Seating/Activities/activities-edit.jsx
 * - src/Seating/Contacts/contact-edit.jsx
 * - src/Seating/Deliveries/deliveryList.jsx
 * - src/Seating/Faxes/faxes.jsx
 * - src/Seating/InventoryProduct/inventoryProductTable.jsx
 * - src/Seating/Patient/PatientViewComponents/typeStatusContainer.jsx
 * - src/Seating/Patient/patientInformationView.jsx
 * - src/Seating/Patient/patientOrderView.jsx
 * - src/Seating/PurchaseQueue/PODeliveryUpdate.jsx
 * - src/Seating/PurchaseQueue/inventoryRequestTable.jsx
 * - src/Seating/PurchaseQueue/purchaseQueueTable.jsx
 * - src/Seating/Settings/addDeliveryAcknowledgement.jsx
 * - src/Seating/Settings/addProdcutMatrixEntry.jsx
 * - src/Seating/Settings/addProductSubType.jsx
 * - src/Seating/Settings/creditCardTypes.jsx
 * - src/Seating/Settings/deliveryAcknowledgements.jsx
 * - src/Seating/Settings/editProductSubTypes.jsx
 * - src/Seating/Settings/expenseTypes.jsx
 * - src/Seating/Settings/manualDocumentBuilder.jsx
 * - src/Seating/Settings/productMatrixEntry.jsx
 * - src/Seating/Settings/productTypes.jsx
 * - src/Seating/Settings/reasons.jsx
 * - src/Seating/Settings/stateSalesTax.jsx
 * - src/Seating/Settings/trainingLink.jsx
 * - src/Seating/Settings/vendor.jsx
 * - src/Seating/Users/thirdPartyUserList.jsx
 * - src/Seating/Users/userAdd.jsx
 * - src/Seating/Users/userEdit.jsx
 */

import MUICardHeader from "@mui/material/CardHeader";

export default function CardHeader({
  children,
  title,
  className,
  color,
  style,
  ...rest
}) {
  return (
    <MUICardHeader
      title={title ?? children}
      className={className}
      style={style}
      color={color}
      {...rest}
    />
  );
}
